// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"f77986bc","420":"d37f113d","787":"905e45e9","855":"50470f6c"}[chunkId] + ".chunk.js";
};